import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import ParametersHeader from "../ParametersHeaders";
import ModelTypes from "./ModelTypes/ModelTypes";
import Models from "./Models/Models";


const Equipment = () =>{
  
    const chipHeaders = ["Είδη Συσκευών", "Τύποι Συσκευών"];
    const chipItems: React.ReactNode[] = [
      <ModelTypes />,
      <Models />
    ];
  
    return (
      <div className="page-content">
        <ParametersHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default Equipment